import type { WorkspaceEdge, WorkspaceNode } from "../../../types/workspace";

/**
 * Whether a forward “Add …” diamond should appear for this parent.
 * Shared by canvas placeholders and layout spacing (branch gaps / organize).
 *
 * Forward placeholders are hidden — users add next steps from the node actions
 * menu instead. Keep this gate so layout stops reserving placeholder corridors.
 */
export function workspaceNodeShowsForwardPlaceholder(
  _parent: WorkspaceNode,
  _edges: WorkspaceEdge[],
  _nodes: WorkspaceNode[],
  _options?: {
    viewMode?: "account" | "strategy";
    compact?: boolean;
    maxSimulationsPerReport?: number;
  }
): boolean {
  return false;
}
